import { Link, useLocation } from "react-router-dom";
import { useDocumentMeta } from "@/hooks/useDocumentMeta";

export default function NotFound() {
  const location = useLocation();

  useDocumentMeta({
    title: "页面不存在-69视频",
    description: "你访问的页面不存在或已被移除，请返回首页继续浏览69视频的丰富内容。",
    keywords: "404,页面不存在,69视频",
    canonicalPath: "/",
  });

  return (
    <div className="relative flex flex-col items-center justify-center min-h-[70vh] text-center px-4 py-16">
      <div className="relative z-10 max-w-lg">
        <p className="font-heading font-black text-7xl md:text-9xl text-primary-100 select-none">404</p>
        <h1 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mt-4">页面走丢了</h1>
        <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">
          你访问的页面不存在或已被移除。当前路径：
          <span className="font-mono text-foreground-800 break-all">{location.pathname}</span>
        </p>
        <div className="flex items-center justify-center gap-3 mt-8 flex-wrap">
          <Link
            to="/"
            className="px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            返回首页
          </Link>
          <Link
            to="/category/movie"
            className="px-6 py-3 rounded-md border border-background-200 text-sm font-medium text-foreground-800 hover:border-primary-400 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            去看电影
          </Link>
        </div>
      </div>
    </div>
  );
}